// Re-export all validation utilities from their respective modules
export * from './validation/validators';
export * from './validation/formatters';

// Additional validation utilities for form field components

// ZIP Code utilities
export const formatZipCode = (value: string): string => {
  // Only allow digits
  const digits = value.replace(/\D/g, "");
  
  // Limit to 9 digits (ZIP or ZIP+4)
  const truncated = digits.substring(0, 9);
  
  // Format as ZIP or ZIP+4
  if (truncated.length <= 5) {
    return truncated;
  } else {
    return `${truncated.slice(0, 5)}-${truncated.slice(5)}`;
  }
};

export const validateZipCode = (value: string): { valid: boolean; message: string } => {
  const cleaned = value.replace(/\D/g, "");
  
  if (cleaned.length === 0) {
    return { valid: false, message: "ZIP code is required" };
  }
  
  if (cleaned.length < 5) {
    return { valid: false, message: "ZIP code must be at least 5 digits" };
  }
  
  if (cleaned.length > 9) {
    return { valid: false, message: "ZIP code cannot exceed 9 digits" };
  }
  
  // Valid if 5 digits or 9 digits (ZIP+4)
  if (cleaned.length !== 5 && cleaned.length !== 9) {
    return { valid: false, message: "ZIP code must be 5 or 9 digits" };
  }
  
  return { valid: true, message: "" };
};

// URL validation utility
export const validateUrl = (value: string): { valid: boolean; message: string } => {
  if (!value) {
    return { valid: true, message: "" }; // Optional field
  }
  
  try {
    new URL(value);
    return { valid: true, message: "" };
  } catch {
    return { valid: false, message: "Please enter a valid URL" };
  }
}; 